/* @jsxImportSource react */

import type { Locale } from '@packages/config';
import config from '@packages/config';
import type { Device } from '@packages/themes/src/default';

import { Header } from './Header';
import { getNavigationDataEndpoint } from './Navigation/getNavigationDataEndpoint';
import { SwrConfigClientWrapper } from './SwrConfigClientWrapper';
import { fetchRequiredStaticJson } from './api';

export type HeaderLoaderProps = {
  locale: Locale;
  device: Device;
};

export const HeaderLoader = async ({ locale, device }: HeaderLoaderProps) => {
  const {
    clientId,
    navigation: { loadSliced },
  } = config;

  const navEndpoint = getNavigationDataEndpoint(
    clientId,
    device === 'desktop' ? 'web' : 'mob',
    locale,
    loadSliced,
  );

  const data = await fetchRequiredStaticJson(navEndpoint, { componentName: 'HeaderLoader' });

  return (
    <SwrConfigClientWrapper fallback={{ [navEndpoint]: data }}>
      <Header />
    </SwrConfigClientWrapper>
  );
};
